import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export type BaseDateTextType = 'date' | 'dateTime';

export const DEFAULT_DATE_FORMATS: Record<BaseDateTextType, string> = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
};

/** 纯日期保留日历含义，时间点转换到浏览器时区；无偏移时间按该时区解释。 */
export function formatDate(
  value: unknown,
  type: BaseDateTextType,
  format?: string,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string {
  if (value === null || value === undefined) return '';
  if (
    typeof value !== 'string' &&
    typeof value !== 'number' &&
    !(value instanceof Date)
  ) {
    return String(value);
  }
  const parsed = dayjs(value);
  if (!parsed.isValid()) return String(value);
  const pattern = format ?? DEFAULT_DATE_FORMATS[type];
  if (
    type === 'date' &&
    typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(value)
  ) {
    return parsed.format(pattern);
  }
  const hasOffset =
    typeof value !== 'string' || /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);
  const zoned = hasOffset ? parsed.tz(timeZone) : dayjs.tz(value, timeZone);
  return zoned.format(pattern);
}

/** 选择器保留Dayjs值与范围元组，仅把时间点显示转换为浏览器本地时区。 */
export function toBrowserTime<T>(value: T): T {
  if (dayjs.isDayjs(value)) return value.local() as T;
  if (Array.isArray(value))
    return value.map((item) => toBrowserTime(item)) as T;
  return value;
}
